import logger from 'helpers/logger'
import formModel from 'containers/Onboarding/FormModels/Models';
import at from 'lodash/at'

const { formField } = formModel;

export function getKycUrlData(jumioUrl) {
    if (!jumioUrl) return {
        originUrl: '',
        sdkToken: ''
    }
    const url = new URL(jumioUrl)
    const queryUrl = new URLSearchParams(url.search);
    const sdkToken = queryUrl.get('authorizationToken')
    const originUrl = url.origin + url.pathname
    return {
        originUrl,
        sdkToken
    }
}

export function scrollToTop() {
    const root = document.getElementById('topMark')
    root?.scrollIntoView?.({ behavior: 'smooth', block: 'center', inline: 'center' })
}

export function makeCapitalizeFunc() {
    // eslint-disable-next-line no-extend-native
    String.prototype.toCapitalize = function () {
        return this.split(' ').map(x => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase()).join(' ')
    }
}


export function removeVietnamese(str) {
    // Gộp nhiều dấu space thành 1 space
    str = str.replace(/\s+/g, ' ');
    // loại bỏ toàn bộ dấu space (nếu có) ở 2 đầu của chuỗi
    str = str.trim();
    // bắt đầu xóa dấu tiếng việt  trong chuỗi
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    return str;
}

export function booleaner(str) {
    if (typeof str === 'boolean') return str
    return !!(str === 'true')
}

export function clone(any) {
    try {
        return any ? JSON.parse(JSON.stringify(any)) : any;
    } catch (error) {
        return any
    }
}

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export function checkShow(listDepend, values) {
    const keys = Object.keys(listDepend)
    for (let index = 0; index < keys.length; index++) {
        const dependValue = at(values, keys[index])[0] ?? {}
        const refs = listDepend[keys[index]]
        if (Array.isArray(dependValue)) {
            for (let i = 0; i < dependValue.length; i++) {
                if (refs.includes(dependValue[i])) return true
            }
            return false
        } else {
            if (!refs.includes(dependValue)) return false
        }
    }
    return true
}

export function handleDataBeforeSubmit(object, originObject, path = '') {
    try {
        Object
            .entries(object)
            .forEach(([k, v]) => {
                const pathField = `${path ? path + '.' : ''}${k}`
                if (v && typeof v === 'object') {
                    handleDataBeforeSubmit(v, originObject, pathField);
                }
                if ((v && typeof v === 'object' && !Object.keys(v).length) || v === null || v === undefined) {
                    if (Array.isArray(object)) {
                        object.splice(k, 1);
                    } else {
                        delete object[k];
                    }
                } else {
                    const model = at(formField, pathField.replace(/\[\d]/, ''))[0] ?? {}
                    if (model && model.depend) {
                        if (!checkShow(model.depend, originObject)) {
                            delete object[k]
                        }
                    }
                }
            });
        return object
    } catch (error) {
        logger.error('handleDataBeforeSubmit error: ', error)
    }
}

// format: '+phone_code|phone_number'
export const hiddenPhone = (phone) => {
    try {
        if (!phone) return '';
        let phoneNumber = phone.split('|')[1] || phone
        if (phoneNumber.startsWith('0')) {
            phoneNumber = phoneNumber.slice(1)
            phone.replace(/^(.*)\s(.*)$/, '$1' + ' ' + phoneNumber)
        }
        phone = phone.replace(/^(.*)(....)(..)$/, '$1****$3').replace(/\|/, '')
        return phone;
    } catch (error) {
        console.error('convert phone to * error: ', error);
        return '';
    }
};

export function isValidHttpUrl(string) {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
}